import { mapForwardCupModeFormat } from "./FsForwardCupModeFormat";
import { ForwardCupModeSet } from "model/Match/Set/CupMode/ForwardCupModeSet";
import { mapForwardCupModeTracks } from "./FsForwardCupModeTrack";
import { nonUndefined } from "Utility";
import { applyScoreOverrides, Scores } from "model/Scores";
import { FsForwardCupModeSet } from "db/model/match/Set/CupMode/Forward/FsForwardCupModeSet";
import { mapMatchSetBase } from "../../FsMatchSet";
import { calculateFinalPositions } from "model/Positions";
import { MatchTeams } from "model/Match/MatchTeams";
import {
  getPlayTill,
  PlayTill,
  playTillReached,
} from "model/Match/Set/CupMode/Format/CupModeFormat";

export const mapForwardCupModeSet = (
  fsModel: FsForwardCupModeSet,
  teams: MatchTeams
): ForwardCupModeSet | undefined => {
  if (!fsModel.format) {
    return undefined;
  }

  const format = mapForwardCupModeFormat(fsModel.format);
  if (!format) {
    return undefined;
  }

  const scores: Scores = {};
  const playTill = getPlayTill(format);
  const tracks = mapForwardCupModeTracks(
    nonUndefined(fsModel.tracks ?? []),
    teams.rosters,
    teams.scope,
    scores,
    format.points,
    format.finalist,
    format.pointsLimit,
    format.roundsPerTrack,
    format.driversPerTeam,
    format.requiredTeamWinners,
    playTill
  );

  applyScoreOverrides(scores, fsModel.scoreOverrides);

  const isComplete =
    fsModel.overrideComplete ||
    calculateIsComplete(scores, format.pointsLimit, playTill);

  if (isComplete) {
    tracks.forEach((t) => (t.isComplete = true));
  }

  const finalPositions = calculateFinalPositions(
    isComplete,
    scores,
    compareScores
  );

  return {
    ...mapMatchSetBase(fsModel, isComplete, finalPositions, scores),
    format,
    isComplete,
    tracks,
    type: "ForwardCupMode",
  };
};

const calculateIsComplete = (
  scores: Scores,
  pointsLimit: number,
  playTill: PlayTill
) => {
  const numRosters = Object.values(scores).length;
  if (numRosters === 0) {
    return false;
  }

  const numLeft = Object.values(scores).filter(
    (s) => s > 0 && s <= pointsLimit
  ).length;
  const numFinished = Object.values(scores).filter(
    (s) => s > pointsLimit
  ).length;

  return playTillReached(playTill, numLeft, numFinished);
};

// todo - Apply tiebreakers here
const compareScores = (scores: Scores, a: string, b: string) => {
  return scores[b] - scores[a];
};
